
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'Industries', to: '#industries' },
    { label: 'Process', to: '#process' },
    { label: 'About', to: '#about' },
    { label: 'Insights', to: '#insights' },
    { label: 'Contact', to: '#contact' },
  ];

  const handleAnchor = (hash: string) => {
    setMobileOpen(false);
    if (hash.startsWith('#')) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled
            ? 'bg-white/80 backdrop-blur-xl shadow-[0_1px_0_rgba(14,26,51,0.06)]'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-8 lg:px-12">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/172799ddc18d4cdef706c1984918906a.png" 
                alt="SkySails AI" 
                className="h-24 w-auto"
              />
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) =>
                link.to.startsWith('#') ? (
                  <a
                    key={link.label}
                    href={link.to}
                    onClick={(e) => {
                      e.preventDefault();
                      handleAnchor(link.to);
                    }}
                    className={`text-[13px] font-medium transition-colors duration-300 cursor-pointer ${
                      isScrolled ? 'text-navy/70 hover:text-navy' : 'text-navy/60 hover:text-navy'
                    }`}
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    key={link.label}
                    to={link.to}
                    className={`text-[13px] font-medium transition-colors duration-300 cursor-pointer ${
                      isScrolled ? 'text-navy/70 hover:text-navy' : 'text-navy/60 hover:text-navy'
                    }`}
                  >
                    {link.label}
                  </Link>
                )
              )}
            </div>

            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                handleAnchor('#contact');
              }}
              className="hidden md:inline-flex px-5 py-2 bg-navy text-white text-[13px] font-medium rounded-full hover:bg-navy/90 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Get Started
            </a>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-navy"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className={`fixed inset-0 z-40 bg-white transition-all duration-500 md:hidden ${
          mobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="pt-24 px-8 flex flex-col gap-6">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.to.startsWith('#') ? link.to : undefined}
              onClick={(e) => {
                e.preventDefault();
                if (link.to.startsWith('#')) handleAnchor(link.to);
                else setMobileOpen(false);
              }}
              className="text-2xl font-light text-navy cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleAnchor('#contact');
            }}
            className="mt-4 inline-flex justify-center px-6 py-3 bg-navy text-white text-sm font-medium rounded-full cursor-pointer whitespace-nowrap"
          >
            Get Started
          </a>
        </div>
      </div>
    </>
  );
}
